export var CheckboxGroupLayout;
(function (CheckboxGroupLayout) {
    CheckboxGroupLayout["Block"] = "block";
    CheckboxGroupLayout["Stack"] = "stack";
    CheckboxGroupLayout["Inline"] = "inline";
    CheckboxGroupLayout["InlineFlex"] = "inline-flex";
    CheckboxGroupLayout["InlineEqualWidth"] = "inline-equal-width";
})(CheckboxGroupLayout || (CheckboxGroupLayout = {}));
export var CheckboxGroupCssClass;
(function (CheckboxGroupCssClass) {
    CheckboxGroupCssClass["Base"] = "iress-checkbox-group";
    CheckboxGroupCssClass["InlineBase"] = "iress-inline iress-checkbox-group--inline";
    CheckboxGroupCssClass["HiddenControl"] = "iress-checkbox-group--hidden-control";
})(CheckboxGroupCssClass || (CheckboxGroupCssClass = {}));
//# sourceMappingURL=checkbox-group.types.js.map